import { isEmail } from "validator";
import { isValidEmailSpelling } from "../../../utils/emailSpellChecker";

const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
const nameRegex = /^[a-zA-Z\s-]+$/;
const phoneRegex = /^\+?[0-9]+$/;

export const validateForm = (form) => {
  const errors = {};
  if (!form.firstName || form.firstName.trim() === "") {
    errors.firstName = "First name is required";
  } else if (!nameRegex.test(form.firstName)) {
    errors.firstName = "Please enter a valid name";
  }
  if (!form.lastName || form.lastName.trim() === "") {
    errors.lastName = "Last name is required";
  } else if (!nameRegex.test(form.lastName)) {
    errors.lastName = "Please enter a valid name";
  }
  if (!form.email || form.email.trim() === "") {
    errors.email = "Email is required";
  } else if (!isEmail(form?.email) || !isValidEmailSpelling(form?.email)) {
    errors.email = "Please enter a valid email";
  }
  if (!form.phoneNumber || form.phoneNumber.trim() === "") {
    errors.phoneNumber = "Phone number is required";
  } else if (!phoneRegex.test(form.phoneNumber)) {
    errors.phoneNumber = "Please enter a valid phone number";
  }

  return errors;
};
